"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersectionObserver = void 0;
const react_1 = require("react");
require("intersection-observer");
const useIntersectionObserver = (ref, handler, options = {}) => {
    (0, react_1.useEffect)(() => {
        if (!ref.current) {
            return undefined;
        }
        const intersectionObserver = new IntersectionObserver(handler, options);
        intersectionObserver.observe(ref.current);
        return () => {
            intersectionObserver.disconnect();
        };
    }, [handler, options, ref]);
};
exports.useIntersectionObserver = useIntersectionObserver;
//# sourceMappingURL=index.js.map